import { useState, useEffect } from 'react'
import {
  Toolbar,
  SaveButton,
  List,
  SimpleForm,
  TextInput,
  Datagrid,
  Edit,
  TextField,
  NumberField,
  Filter,
  SearchInput,
  BooleanField,
  useRefresh,
  SelectInput,
  BooleanInput,
  useRecordContext,
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import { DialogForm } from './components/DialogForm'
import { formatPhone, validatePhone } from './utils'
import { PreviewButton, UrlFieldDownload } from './components/file_upload'
import { Box, Grid } from '@material-ui/core'
import config from './config'
import WarningIcon from '@mui/icons-material/Warning'

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export const CustomToolbar = (props) => (
  <Toolbar {...props} classes={useStyles()}>
    <SaveButton />
  </Toolbar>
)

const ContactFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
)

const ConcentCol = () => {
  const { id, signature_path } = useRecordContext()
  const [record, setRecord] = useState()
  if (!signature_path) return null
  useEffect(() => {
    const request = new Request(`${config.API_V1}/contacts/${id}/concent`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    })
    fetch(request)
      .then(async (response) => await response.json())
      .then((r) => setRecord(r))
  }, [id])
  if (!record) return null

  return (
    <Grid container>
      <Grid item>
        <PreviewButton record={record} source="file" isBase64File={true} />
      </Grid>
      <Grid item>
        <UrlFieldDownload
          record={record}
          source="file"
          isBase64File={true}
          download={true}
        />
      </Grid>
    </Grid>
  )
}

export const ContactsList = (props) => {
  const [internal_id, setInternalId] = useState()
  return (
    <>
      <List
        {...props}
        exporter={false}
        filters={<ContactFilter />}
        perPage={100}
        sort={{ field: 'id', order: 'DESC' }}
      >
        <Box
          sx={{
            margin: '15px 0 0 0',
            textAlign: 'center',
            fontSize: '13px',
            color: 'rgb(245, 160, 75)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <WarningIcon sx={{ margin: '0 10px 0 0' }}></WarningIcon>
          <Box>
            L'édition d'un Contact est disponible uniquement via Copromatic. Vos
            modifications seront prises en compte lors de la mise à jour
            nocturne de Copromatic.
          </Box>
        </Box>
        <Datagrid
          bulkActionButtons={false}
          rowClick={(id) => {
            setInternalId(id)
          }}
          rowStyle={() => ({ cursor: 'default' })}
        >
          <NumberField source="id" label="Id" />
          <TextField source="copromatic_id" label="Id copromatic" />
          <TextField source="fullname" label="Nom" />
          <TextField source="libelle" label="Libellé" />
          <TextField source="tel" label="Tel" />
          <TextField source="mobile" label="Mobile" />
          <TextField source="mail" label="Email" />
          <TextField source="adresse" />
          <BooleanField source="paper" />
          <TextField source="pref_contact" />
          <BooleanField source="is_cs" />
          <ConcentCol label="Concent" />
        </Datagrid>
      </List>
      {/* {internal_id && <EditDialog id={internal_id} />} */}
    </>
  )
}

// FIXME: Temporary disable because Contact edition should be handled by Copromatic for the moment
// Webhook will be implemented to update the data in the future

// const EditDialog = ({ id }) => {
//   const refresh = useRefresh()

//   return (
//     <DialogForm
//       title="Modifier mes préférences de contact"
//       id={id}
//       open={id}
//       showButtonProps={{ sx: { display: 'none' } }}
//       onSuccess={() => {
//         refresh()
//       }}
//       transform={(data) => {
//         data.tel = formatPhone(data.tel)
//         data.mobile = formatPhone(data.mobile)
//         return data
//       }}
//     >
//       <SimpleForm toolbar={<CustomToolbar />} resource="contacts">
//         <TextField source="fullname" label="Nom" />
//         <TextInput source="mail" label="Email" />
//         <TextInput source="tel" label="Tel. fixe" validate={validatePhone} />
//         <TextInput source="mobile" label="Mobile" validate={validatePhone} />
//         <SelectInput
//           source="prefcontact"
//           label="Préférence contact"
//           choices={[
//             { id: 'all', name: 'Email et SMS' },
//             { id: 'email', name: 'Email' },
//             { id: 'sms', name: 'SMS' },
//           ]}
//         />
//         <BooleanInput source="paper" />
//       </SimpleForm>
//     </DialogForm>
//   )
// }

export const ContactEdit = (props) => (
  <Edit
    {...props}
    transform={(data) => {
      data.tel = formatPhone(data.tel)
      data.mobile = formatPhone(data.mobile)
      return data
    }}
  >
    <SimpleForm toolbar={<CustomToolbar />}>
      <TextField source="fullname" label="Nom" />
      <TextInput source="mail" label="Email" />
      <TextInput source="tel" label="Tel. fixe" validate={validatePhone} />
      <TextInput source="mobile" label="Mobile" validate={validatePhone} />
      <SelectInput
        source="prefcontact"
        label="Préférence contact"
        choices={[
          { id: 'all', name: 'Email et SMS' },
          { id: 'email', name: 'Email' },
          { id: 'sms', name: 'SMS' },
        ]}
      />
      <BooleanInput source="paper" />
    </SimpleForm>
  </Edit>
)
